// import About from "./components/About";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Portfolio from "./components/Portfolio";
// import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';


import AutonomousRCCar from './components/AutonomousRCCar';
import RobotArm from './components/RobotArm';
import RoboSoccer from './components/RoboSoccer';
import Praxis from './components/Praxis';

import SplineInterpolation from './components/SplineInterpolation';
import StackMap from './components/StackMap';

import Contact from "./components/Contact";



function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Portfolio />} />
        <Route path="/projects/autonomousrccar" element={<AutonomousRCCar />} />
        <Route path="/projects/robotarm" element={<RobotArm />} />
        <Route path="/projects/robosoccer" element={<RoboSoccer />} />
        <Route path="/projects/robosoccer/map" element={<StackMap />} />
        <Route path="/projects/praxis" element={<Praxis />} />
        <Route path="/projects/splineinterpolation" element={<SplineInterpolation />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
